import { isDisclosureListItem } from "@/api/fetchDisclosureList/common/isDisclosureListItem";
import { GQL_EXCHANGE_TYPE } from "@/shared/Disclosure/types/GQL/enum/ExchangeType";
import { PV_DISCLOSURE_PAGE } from "@/types/PresenterModel/PV_DISCLOSURE_PAGE";
import { API_REQ_DISCLOSURE_LIST } from "@/types/apiModel/Disclosure/API_REQ_DISCLOSURE_LIST";
import createGraphqlClient from "@/utils/createGraphqlClient";
import { gql } from "graphql-request";
import {
  API_RES_DISCLOSURE_SHENZHEN,
  API_RES_SHENZHEN_LIST_ITEM
} from "../../../types/apiModel/Disclosure/API_RES_DISCLOSURE_SHENZHEN";
import commonQueryFilter from "../common/commonQueryFilter";
import { PV_DISCLOSURE_ITEM } from "@/types/PresenterModel/PV_DISCLOSURE_ITEM";
import parseItem from "./parseShenzhenListItem";

const exchangeType = GQL_EXCHANGE_TYPE.SHENZHEN;

const query = (p: API_REQ_DISCLOSURE_LIST, limit = 100) => gql`
query disclosureListShenzhen {
  getDisclosure(
    filter: {
    ${commonQueryFilter(p, limit)}
}) {
    id
    dataDate
    korName
    details {
      ... on Shenzhen {
        secName
        secCode
        categoryId
        fileType
      }
    }
    analysisDetails {
      topicKor
      summarizeTinyKor
      summarizeLongKor
    }
  }
}
`;

async function parser(
  data: API_RES_DISCLOSURE_SHENZHEN,
  pageNumber: number
): Promise<PV_DISCLOSURE_PAGE> {
  return {
    list: await parse(data?.getDisclosure),
    pageNumber,
    exchangeType
  };
}

async function parse(
  list: API_RES_SHENZHEN_LIST_ITEM[]
): Promise<PV_DISCLOSURE_ITEM[]> {
  return (await Promise.all((list || []).map(parseItem))).filter(
    isDisclosureListItem
  );
}

export async function reqShenzhenDisclosureList(p: API_REQ_DISCLOSURE_LIST) {
  const client = createGraphqlClient();
  return parser(await client.request(query(p)), p.page);
}
